import { CalendarDays } from "lucide-react";
import { useLang } from "@/App";
import { Reveal, ChapterHead } from "@/components/Section";

const IMG_CLOCHE = "https://prieure-saint-leonard.fr/photos/prieure-sunset.jpg";

const Fetes = () => {
  const { t } = useLang();
  return (
    <section id="fetes" data-testid="fetes-section" className="relative px-5 md:px-10 py-28 md:py-40 scroll-mt-20">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <ChapterHead kicker={t.fetes.kicker} title={t.fetes.title} testId="fetes" />
          <Reveal delay={0.1}>
            <div className="space-y-6 max-w-2xl -mt-6 md:-mt-10">
              {t.fetes.paragraphs.map((p, i) => (
                <p key={i} data-testid={`fetes-paragraph-${i}`} className="font-display text-xl md:text-2xl leading-relaxed text-ink2 first:text-ink">
                  {p}
                </p>
              ))}
            </div>
            <div className="mt-12 border-t border-line" data-testid="fetes-cards">
              {t.fetes.cards.map((c, i) => (
                <div key={i} data-testid={`fetes-card-${i}`} className="group flex gap-5 items-start py-6 border-b border-line px-2 -mx-2 hover:bg-parchment/60 transition-colors">
                  <CalendarDays size={18} className="text-terra mt-2 shrink-0" />
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl text-ink group-hover:text-terra transition-colors leading-tight">{c.title}</h3>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted2 mt-2">{c.detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 border border-bronze/40 translate-x-4 translate-y-4" />
              <div className="relative overflow-hidden aspect-[3/4] border border-line shadow-[0_30px_80px_-30px_rgba(33,26,19,0.4)]">
                <img src={IMG_CLOCHE} alt="Le Prieuré Saint-Léonard à l'heure dorée" loading="lazy" className="w-full h-full object-cover img-lumiere hover:scale-[1.04] transition-transform duration-[1400ms] ease-out" />
              </div>
              <p data-testid="fetes-caption" className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted2 mt-6 text-right">
                {t.fetes.caption}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Fetes;
